export default function Devchip(){

    return(
        <p className="chip-cont devchip">
            Dev
        </p>
    )
}